import { Spin, Typography } from 'antd';
import { useQuery } from 'react-query';
import { NavLink } from 'react-router-dom';
import { environment } from '../../environment';
import { Book } from '../../models/books';
import { getBook } from '../../service/book';
import { getBooksGenres } from '../../service/genres';
import BookImage from '../BookImage/BookImage';
import styles from './Book.module.scss';
const { Paragraph, Text } = Typography;

type Props = Pick<Book, 'imageLink' | 'author' | 'page' | 'name'>

interface PropsBookProxy {
  book?: Book
  bookId?: number
  partialBook?: Pick<Book, 'imageLink' | 'author' | 'page' | 'name'>
}

export const BookProxy = ({ bookId, book, partialBook }: PropsBookProxy) => {
  if (book && book.id) return <BookContainer book={book} />

  if (bookId) return <BookWithId bookId={bookId} />

  if (partialBook) return <BookWithoutId {...partialBook}/>

  return <></>
}

export const BookWithoutId = ({ imageLink, author, page, name }: Props) => {
  author = Array.isArray(author) ? author.join(', ') : author
  imageLink = imageLink || environment.noCoverBook

  return(
    <div className={styles.container}>
      <section className={styles.containerImage}>
      <BookImage 
        className={styles.image} 
        path={imageLink} 
        author={author}
        name={name}
        />
      </section>
      <section className={styles.containerInfo}>
        <h2><strong>{name}</strong></h2>
        <h3><strong>Autor:</strong> {author}</h3>
        <div className={styles.footerInfo}>
          <span>{page || 0} páginas </span>
        </div>
      </section>
    </div>
  )
}

export const BookWithId = ({bookId}) => {
  const {data:book, isFetching} = useQuery(
    ['books', bookId],
    () => getBook(bookId),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false}
  );

  const {data: genres} = useQuery(
    ['genres', bookId],
    () => getBooksGenres(Number(bookId)),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false}
  );

  if(isFetching) return <Spin spinning={isFetching}/>

  return(
    <div className={styles.container}>
      <section className={styles.containerImage}>
      <BookImage 
        className={styles.image} 
        path={book?.imageLink} 
        author={String(book?.author)}
        name={book?.name}
        />
      </section>
      <section className={styles.containerInfo}>
        <h2><strong>{book?.name}</strong></h2>
        <h3><strong>Autor:</strong> {book?.author}</h3>
        {!!genres?.length && <h2 className={styles.genres}>Gêneros: {genres?.slice(0,4).map(genre => genre.content).join(', ')} ...</h2>} 
        <div className={styles.footerInfo}>
          <span>{book?.page} páginas / Ano: 2012</span>
        </div>
        {
          book?.description ?
          <>
            <Paragraph ellipsis={{ rows: 2, expandable: false }}>
            Sinopse: {book?.description || ''}
            </Paragraph>
          </>
          : null
        }
        <NavLink to={`/book/local/${book?.id}`}>Visualizar livro</NavLink>

      </section>
    </div>
  )
}

interface BookContainerProps {
  book:Book
}

export const BookContainer = ({ book }: BookContainerProps) => {
  const { data: genres } = useQuery(
    ['genres', book.id],
    () => getBooksGenres(book.id),
    { refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false }
  );

  return (
    <div className={styles.container}>
      <section className={styles.containerImage}>
        <BookImage
          className={styles.image}
          path={book?.imageLink}
          author={String(book?.author)}
          name={book?.name}
        />
      </section>
      <section className={styles.containerInfo}>
        <h2><strong>{book?.name}</strong></h2>
        <h3><strong>Autor:</strong> {book?.author}</h3>
        {!!genres?.length && <h2 className={styles.genres}>Gêneros: {genres?.slice(0, 4).map(genre => genre.content).join(', ')} ...</h2>}
        <div className={styles.footerInfo}>
          <span>{book?.page} páginas / Ano: 2012</span>
        </div>
        {
          book?.description ?
            <>
              <Paragraph ellipsis={{ rows: 2, expandable: false }}>
                Sinopse: {book?.description || ''}
              </Paragraph>
            </>
            : null
        }
        <NavLink to={`/book/local/${book?.id}`}>Visualizar livro</NavLink>

      </section>
    </div>
  )
}

export { BookProxy as CustomBook }